// extracted by mini-css-extract-plugin
export var backButton = "_1a-1";
export var content = "_1a-d";
export var continueButton = "_1a-7";
export var continueHint = "_1a-8";
export var continueRow = "_1a-6";
export var leftInner = "_1a-0";
export var shell = "_1a-e";
export var sidebarContent = "_1a-5";
export var skipButton = "_1a-c";
export var spacer = "_1a-2";
export var spin = "_1a-a";
export var spinner = "_1a-9";
export var spinnerOverlay = "_1a-b";
export var subtitle = "_1a-4";
export var title = "_1a-3";